import React from 'react';
import { Box, Paper } from '@mui/material';
import ContentLoader from 'react-content-loader';

const SkeletonComment = () => (
  <Box sx={{ mb: 2 }}>
    <Paper elevation={2} sx={{ p: 2, borderRadius: '4px' }}>
      <ContentLoader
        speed={2}
        width="100%"
        height={80}
        backgroundColor="#3D393B"
        foregroundColor="#4A494B"
      >
        {/* Avatar */}
        <circle cx="20" cy="20" r="16" />
        
        {/* Username and timestamp */}
        <rect x="44" y="5" rx="4" ry="4" width="120" height="12" />
        <rect x="44" y="25" rx="4" ry="4" width="80" height="10" />

        {/* Comment text */}
        <rect x="0" y="50" rx="5" ry="5" width="100%" height="10" />
        <rect x="0" y="65" rx="5" ry="5" width="80%" height="10" />
      </ContentLoader>
    </Paper>
  </Box>
);

export default SkeletonComment;
